import { Directive, Input, OnInit, inject } from '@angular/core';
import { DxiColumnComponent } from 'devextreme-angular/ui/nested';
import { UserService } from 'src/app/user/services';
import { DateTimeService } from '../datetime/datetime.service';

@Directive({ 
    // eslint-disable-next-line @angular-eslint/directive-selector
    selector: 'dxi-column[biz-grid-date]' })

export class BizDateColumnDirective implements OnInit {
    @Input() public format: DateFormat;
    private column = inject(DxiColumnComponent);

    constructor(public dateTimeService: DateTimeService) {
    }

    async ngOnInit() {
        this.column.allowEditing = false;
        this.column.dataType = 'date';
        this.column.formItem = {visible: false};
        this.column.calculateDisplayValue = this.formatDate;
    }

    formatDate = (rowData) => {
        const dataField = this.column.dataField;
        const date = this.getPropertyValue(dataField, rowData);

        if (date) {

            switch (this.format) {
                case DateFormat.Date:
                    return this.dateTimeService.getDevExpressDateFunction(date);
                case DateFormat.Time:
                    return this.dateTimeService.getFormattedTime(date);
                case DateFormat.DateTime:
                    return this.dateTimeService.getDevExpressDateTimeFunction(date);
                case DateFormat.DateTimeMs:
                    return this.dateTimeService.getDevExpressDateTimeWithMsFunction(date);
                default:
                    return this.dateTimeService.getDevExpressDateTimeFunction(date);
            }
        }
        else {
            return '';
        }
    };

    getPropertyValue(path: string, obj: any): any {
        return path.split('.')
        .reduce((prev: any, curr: string) => prev ? prev[curr] : null , obj || self);
    }
};

export enum DateFormat {
    Date = 'date',
    Time = 'time',
    DateTime = 'dateTime',
    DateTimeMs = 'dateTimeMs'
}
